
import { createReducer } from "@reduxjs/toolkit";

const initialState = {
  loading: false,
  status: null,
  message: null,
  data: null,
};

const sectorReducer = createReducer(initialState, {
  SECTOR_REQ: (state) => {
    state.loading = true;
    state.user = null;
  },
  SECTOR_FETCH_SUC: (state, actions) => {
    state.loading = false;
    state.status = null;
    state.message = null;
    state.data = actions.payload;
  },
  SECTOR_DETAIL_FETCH_SUC: (state, actions) => {
    const payload = actions.payload;
    state.loading = false;
    state.status = payload.status;
    state.message = payload.message;
    state.data = payload.data;
  },
  SECTOR_ERROR: (state, actions) => {
    state.loading = false;
    state.status = null;
    state.message = null;
    state.data = null;
  },
});

export default sectorReducer;